import React from 'react'
import classNames from 'classnames'
import { bool, node, string } from 'prop-types'

import styles from './TextAlign.module.scss'

const TextAlign = ({ center, children, justify, left, right, className }) => {
  const getAlignmentType = () => {
    if (center) return 'center'
    if (justify) return 'justify'
    if (left) return 'left'
    if (right) return 'right'
  }

  const alignmentType = getAlignmentType()

  return (
    <div
      className={classNames(
        styles.TextAlign,
        alignmentType && styles[alignmentType],
        className
      )}
    >
      {children}
    </div>
  )
}

TextAlign.propTypes = {
  children: node.isRequired,
  center: bool,
  justify: bool,
  left: bool,
  right: bool,
  className: string
}

export default TextAlign
